<template>
  <WdsStack gap-sm direction-column>
    <WdsSelect
      v-model="selectedStatuses"
      multi-select
      searchable
      data-test="contacts-filter-status"
      :label="meta.filter.quickFilter ? '' : $t('Status')"
      :list="statusOptions"
      :placeholder="$t('All statuses')"
      can-deselect
      labels-primary
    />
  </WdsStack>
</template>

<script setup lang="ts">
import { WdsSelect, WdsStack } from '@worksome/wds-components'
import { computed, ModelRef } from 'vue'
import { $t } from '@/composables/translation'
import { RecruiterStatus } from '@/gql/graphql'
import { FilterMetaDataProp } from '@/components/GraphqlDataTable/filters/types'

defineProps<{ meta: FilterMetaDataProp }>()

const selectedStatuses: ModelRef<string[]> = defineModel({
  default: () => [],
})

const statusOptions = computed(() => [
  { label: $t('Active'), value: RecruiterStatus.Active },
  { label: $t('Invited'), value: RecruiterStatus.Invited },
])
</script>
